import angular from 'angular';
import gridHeight from "../../core/shared-service/grid-utils";

(function () {
    'use strict';

    angular.module('app.link_request').component('kissLinkRequestList', {
        bindings: {
            sens: '<',			 // Filtre sur le sens BUYER ou SELLER
            legalEntity: '=',
            connexions: '=',
            principal: '<'
        },
        controller: linkRequestListCtrl,
        templateUrl: require('./link-request-list.html')
    });

    linkRequestListCtrl.$inject = ['linkRequestSvc', 'KISS_INVITED_ENTITY', 'LINK_REQUEST', 'InvBuyerLinkRequestFilter', 'PrincipalSvc', 'KissSellerSvc', '$state', '$window'];

    function linkRequestListCtrl(linkRequestSvc, KISS_INVITED_ENTITY, LINK_REQUEST, InvBuyerLinkRequestFilter, PrincipalSvc, KissSellerSvc, $state, $window) {
        var ctrl = this;
        ctrl.LINK_REQUEST = LINK_REQUEST;
        ctrl.back = back;
        ctrl.getGridHeight = getGridHeight;
        ctrl.exportCsvOrXlsx = exportCsvOrXlsx;
        ctrl.searchLinkRequests = searchLinkRequests;
        ctrl.clearForm = clearForm;
        ctrl.searchCompanies = searchCompanies;
        ctrl.searchSubEntitiesByNameOrCode = searchSubEntitiesByNameOrCode;

        ctrl.$onInit = function () {
            this.export = "";
            this.sens === this.LINK_REQUEST.TYPE.client ? this.legalEntityId = this.legalEntity.invitedEntity.legalEntity.id :
                this.legalEntityId = this.legalEntity.id;
            this.hasCooperative = this.connexions.some(relation => 
                    (relation.cooperativeName != null && relation.cooperativeName != undefined));
            this.searchData = new InvBuyerLinkRequestFilter();
            this.statusList = KISS_INVITED_ENTITY.linkRequest.linkRequestStatus;
            this.gridOptions = {
                columnDefs: [
                    {
                        name: 'communityName',
                        displayName: 'link_request.column.community_name',
                        headerCellFilter: 'translate',
                        sort: 'asc'

                    },
                    {
                        name: 'sellerName',
                        displayName: 'link_request.column.seller_name',
                        headerCellFilter: 'translate',
                    },
                    {
                        name: 'buyerName',
                        displayName: 'link_request.column.buyer_name',
                        headerCellFilter: 'translate',
                    },
                    {
                        name: 'buyerSubEntityName',
                        displayName: 'Etablissement Client',
                        headerCellFilter: 'translate',
                    },
                    {
                        name: 'sellerSubEntityName',
                        displayName: 'Etablissement/Division Fournisseur',
                        headerCellFilter: 'translate',
                    },
                    {
                        name: 'enabledServices',
                        displayName: 'link_request.column.service',
                        headerCellFilter: 'translate',
                        minWidth: '300',

                    },
                    {
                        name: 'codeErp',
                        displayName: 'Code ERP',
                        headerCellFilter: 'translate',

                    },
                    {
                        name: 'cooperativeName',
                        displayName: 'Groupement',
                        headerCellFilter: 'translate',

                    },
                    {
                        name: 'creationDate',
                        displayName: 'link_request.column.creation_date',
                        headerCellFilter: 'translate',
                    },
                    {
                        name: 'responseDate',
                        displayName: 'link_request.column.seller_response_date',
                        headerCellFilter: 'translate',
                    },
                    {
                        name: 'status',
                        displayName: 'link_request.column.status',
                        headerCellFilter: 'translate',
                    },

                ],
                onRegisterApi: gridApi => (this.gridApi = gridApi),
                enableSorting: true,
                enableGridMenu: false,
                enableColumnMenus: false,
                data: this.connexions
            };
            this.gridOptions.columnDefs[1].visible = this.sens === this.LINK_REQUEST.TYPE.client;
            this.gridOptions.columnDefs[2].visible = this.sens === this.LINK_REQUEST.TYPE.fournisseur;
            this.gridOptions.columnDefs[7].visible = this.hasCooperative;
        }

        function back() {
            $window.history.back();
        }

        function getGridHeight(gridApi) {
            return gridHeight(gridApi);
        }

        function exportCsvOrXlsx(format) {
            this.export = "";
            if (format) {
                return format === "CSV" ? linkRequestSvc.getLinkRequestExport(this.searchData, "CSV", this.legalEntityId, this.sens)
                    : linkRequestSvc.getLinkRequestExport(this.searchData, "XLS", this.legalEntityId, this.sens);
            }
        }

        function searchLinkRequests() {
            return linkRequestSvc.getLinkRequests(this.legalEntityId, this.searchData, this.sens).then(
                connexions => {
                    this.gridOptions.data = connexions;
                    this.preparedSearchFilter = this.searchData.prepareBeforeSearch();
                },
                (/*error*/) => {
                    this.logger.error('error.search');
                }
            );
        }

        function clearForm() {
            // Reset data
            this.searchData = new InvBuyerLinkRequestFilter();
            this.searchLinkRequests();
        }

        function searchCompanies(value) {
            if (value && value.length >= 3) {
                return PrincipalSvc.searchCompanies(value).then(companies => {
                    return companies;
                });
            }
        }

        function searchSubEntitiesByNameOrCode(value) {
            if (value && value.length >= 3) {
                return linkRequestSvc.searchSubEntitiesByNameOrCode(value).then(subEntities => {
                    return subEntities;
                });
            }
        }
    }
})();
